import { create } from 'zustand';

import { QUALIFYING_ACTION_DELAY, ReviewPlatform, ReviewPrizepoolStep } from '../constants';
import { isEligibleForReviewPrizepool } from './eligibility';

interface ReviewPrizepoolState {
    open: boolean;
    step: ReviewPrizepoolStep;
    dismissed: boolean;
    visited: Record<ReviewPlatform, boolean>;
    openPopup: () => void;
    setStep: (step: ReviewPrizepoolStep) => void;
    dismiss: () => void;
    markPlatformVisited: (platform: ReviewPlatform) => void;
    markQualifyingAction: () => Promise<void>;
}

export const useReviewPrizepoolStore = create<ReviewPrizepoolState>((set, get) => ({
    open: false,
    step: ReviewPrizepoolStep.Intro,
    dismissed: false,
    visited: {
        [ReviewPlatform.Trustpilot]: false,
        [ReviewPlatform.G2]: false,
    },
    openPopup: () => set({ open: true, step: ReviewPrizepoolStep.Intro }),
    setStep: step => set({ step }),
    dismiss: () => set({ open: false, dismissed: true }),
    markPlatformVisited: platform => set(state => ({ visited: { ...state.visited, [platform]: true } })),
    markQualifyingAction: async () => {
        if (!(await isEligibleForReviewPrizepool())) {
            return;
        }

        setTimeout(() => {
            if (get().dismissed || get().open) {
                return;
            }

            set({ open: true, step: ReviewPrizepoolStep.Intro });
        }, QUALIFYING_ACTION_DELAY);
    },
}));
